import React from "react";
// import { AiOutlineInstagram, AiOutlineFacebook } from "react-icons/ai";
import {
  // BsMessenger,
  BsInstagram,
  BsWhatsapp,
  // BsFillTelephoneFill,
} from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";
import { Link } from "react-router-dom";
// import styles from "./styles.module.css";
// import GoogleFormButton from "./GoogleFormButton";
import LinkButton from './LinkButton';

const Topheader = () => {


  return (
    <div className="hidden lg:w-full h-11 bg-maroon lg:flex md:flex-shrink md:justify-evenly md:items-center">
      <div >
       <Link to="/ApplyNow"><button className="w-32 h-7 text-maroon bg-white rounded-3xl font-bold ani">APPLYNOW</button></Link> 
      </div>
      {/* <button className="w-32 h-7 text-maroon bg-white rounded-3xl font-bold">
        
      </button> */}
      <div className="text-gray-200 flex justify-evenly w-48">
       <a href="https://www.facebook.com/emaaninstitute">
        <FaFacebookF />
        </a> 
        <a href="https://www.instagram.com/emaan_institute/">
        <BsInstagram />
        </a>
        <BsWhatsapp />
      </div>
      <div className=" flex justify-around w-32 align-middle">
        {/* <h1>link</h1> */}
        
        <div><LinkButton url="https://esdc.emaan.edu.pk" text="ESDC" /> </div>
        <div>
      <LinkButton url="https://library.emaan.edu.pk/" text="Library" />
      </div>
      </div>
      
    </div>
  );
};

export default Topheader;
